<div class="page-header"><h1 class="page-title">Settings</h1></div>

<nz-tabset [nzTabPosition]="'top'" nzSize="small" [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="selectedTabIndex = $event">
	<nz-tab [nzTitle]="'Partner'" class="m-0">

		<div class="settings-card">
			<div class="settings-card-title">Email</div>
			<div class="settings-card-desc">Outbound notification email configuration.</div>
			<div class="settings-field" *ngFor="let property of emailProperties; trackBy: trackByProperty">
				<label class="settings-field-label" [attr.for]="'property_' + property.name">{{property.name}}</label>
				<input type="text" class="form-control" [id]="'property_' + property.name" [(ngModel)]="property.value" name="property_{{property.name}}"/>
				<div class="settings-field-hint" *ngIf="property.description">{{property.description}}</div>
			</div>
		</div>

		<div class="settings-card">
			<div class="settings-card-title">OTP</div>
			<div class="settings-card-desc">One-time-passcode expiry and attempt limits.</div>
			<div class="settings-field" *ngFor="let property of otpProperties; trackBy: trackByProperty">
				<label class="settings-field-label" [attr.for]="'property_' + property.name">{{property.name}}</label>
				<input type="text" class="form-control" [id]="'property_' + property.name" [(ngModel)]="property.value" name="property_{{property.name}}"/>
				<div class="settings-field-hint" *ngIf="property.description">{{property.description}}</div>
			</div>
		</div>

		<div class="settings-card">
			<div class="settings-card-title">Agent</div>
			<div class="settings-card-desc">Session, password-history, and login-attempt limits.</div>
			<div class="settings-field" *ngFor="let property of agentProperties; trackBy: trackByProperty">
				<label class="settings-field-label" [attr.for]="'property_' + property.name">{{property.name}}</label>
				<input type="text" class="form-control" [id]="'property_' + property.name" [(ngModel)]="property.value" name="property_{{property.name}}"/>
				<div class="settings-field-hint" *ngIf="property.description">{{property.description}}</div>
			</div>
		</div>

		<div class="settings-card">
			<div class="settings-card-title">JWT</div>
			<div class="settings-card-desc">Session token signing and expiry.</div>
			<div class="settings-field" *ngFor="let property of jwtProperties; trackBy: trackByProperty">
				<label class="settings-field-label" [attr.for]="'property_' + property.name">{{property.name}}</label>
				<input type="text" class="form-control" [id]="'property_' + property.name" [(ngModel)]="property.value" name="property_{{property.name}}"/>
				<div class="settings-field-hint" *ngIf="property.description">{{property.description}}</div>
			</div>
		</div>

		<div class="settings-card">
			<div class="settings-card-title">Data Import</div>
			<div class="settings-card-desc">File-import worker and queue configuration.</div>
			<div class="settings-field" *ngFor="let property of dataFileImportProperties; trackBy: trackByProperty">
				<label class="settings-field-label" [attr.for]="'property_' + property.name">{{property.name}}</label>
				<input type="text" class="form-control" [id]="'property_' + property.name" [(ngModel)]="property.value" name="property_{{property.name}}"/>
				<div class="settings-field-hint" *ngIf="property.description">{{property.description}}</div>
			</div>
		</div>

		<div class="settings-card">
			<div class="settings-card-title">Third Party</div>
			<div class="settings-card-desc">IPRS rate limiting and related integration settings.</div>
			<div class="settings-field" *ngFor="let property of thirdPartyProperties; trackBy: trackByProperty">
				<label class="settings-field-label" [attr.for]="'property_' + property.name">{{property.name}}</label>
				<input type="text" class="form-control" [id]="'property_' + property.name" [(ngModel)]="property.value" name="property_{{property.name}}"/>
				<div class="settings-field-hint" *ngIf="property.description">{{property.description}}</div>
			</div>
		</div>

		<div class="settings-card">
			<div class="settings-card-title">Other</div>
			<div class="settings-card-desc">Everything that doesn't belong to a specific group above.</div>
			<div class="settings-field" *ngFor="let property of otherProperties; trackBy: trackByProperty">
				<label class="settings-field-label" [attr.for]="'property_' + property.name">{{property.name}}</label>
				<input type="text" class="form-control" [id]="'property_' + property.name" [(ngModel)]="property.value" name="property_{{property.name}}"/>
				<div class="settings-field-hint" *ngIf="property.description">{{property.description}}</div>
			</div>
		</div>

		<div class="d-flex justify-content-end" *hasPermission="['PermissionEdit']">
			<button class="btn btn-primary" (click)="doSubmit()">Save</button>
		</div>

		<div class="danger-zone" *hasPermission="['AgentClearAllSystemData']">
			<div class="danger-zone-title">Danger zone</div>
			<div class="danger-zone-desc">Permanently clears all system data. This cannot be undone. Requires an OTP sent to your registered contact before it can proceed.</div>
			<button class="btn btn-danger" (click)="clearAllSystemData()">Clear all system data</button>
		</div>

	</nz-tab>
	<nz-tab [nzTitle]="'Change history'" class="m-0" *hasPermission="['AuditModificationList']">
		<app-audit-timeline *ngIf="selectedTabIndex == 1" [audits]="(modifications! | async)!" [downloadHeading]="'Property Audit'" [downloadName]="'property_audit'"></app-audit-timeline>
	</nz-tab>
</nz-tabset>
